<template>
  <section id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <div class="xblock BalanceBox">
          <ul class="BalanceList">
            <li class="BalanceTxt">总收入</li>
            <li><i class="BalanceCount" v-text="data_total.total"></i>元</li>
          </ul>
          <ul class="BalanceList">
            <li class="BalanceTxt">已提现</li>
            <li><i class="BalanceCount" v-text="data_total.cashed"></i>元</li>
          </ul>
          <ul class="BalanceList">
            <li class="BalanceTxt">余额</li>
            <li><i class="BalanceCount" v-text="data_total.balance"></i>元</li>
          </ul>
          <div class="BalanceButton" v-on:click="withdraw('前往提现')">立即提现</div>
        </div>

        <div class="xblock layui-form">
          <div class="layui-input-inline country_select xblock-row">
            <select name="status" lay-verify="required" lay-filter="status_selection">
              <option value="0">所有状态</option>
              <option :value="item.id" v-for="item in status" v-text="item.name"></option>
            </select>
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
          </div>
          <div class="x-right xblock-row">
            <span class="x-right" v-text="'共有数据：'+count+ '条'"></span>
            <span class="x-right" v-text="'总额：'+money+ '元　|　'"></span>
          </div>
          <div class="clear-both"></div>
        </div>

        <table class="layui-table">
          <thead>
            <tr>
              <th>类型</th>
              <th>头像</th>
              <th>名称</th>
              <th>金额</th>
              <th>状态</th>
              <th>时间</th>
            </tr>
          </thead>
          <tbody>
            <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
              <td>微信零钱</td>
            <td>
              <div class="table_img">
                <img v-if="item.head_url && item.head_url != 'null'" :src="item.head_url">
                <img v-else src="../../../static/images/avatar.png">
              </div>
            </td>
            <td v-text="item.name"></td>
              <td v-text="item.money"></td>
              <td>
                <i v-if="item.is_handle == 1" class="status-box status-box-blue">审核中</i>
                <i v-else-if="item.is_handle == 2" class="status-box status-box-green">已通过</i>
                <i v-else class="status-box status-box-red">已拒绝</i>
              </td>
              <td v-text="item.create_at"></td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

      <!-- 分页 -->
      <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

      <!-- 确认框 -->
      <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

    </div>
  </section>
</template>

<script>
  var self, form, layer, laypage, laydate;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'MemberRechargeLog',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        id:null,
        etype:2,
        loading: false,
        isLoding: true,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        money: 0,
        page_num: 20,
        current_status: 0,
        status_id: 0,
        list: [],
        data_total: {
          total: 0,
          cashed: 0,
          balance: 0,
        },
        status: [{
          id: 1,
          name: "待审核"
        }, {
          id: 2,
          name: "已通过"
        }, {
          id: 3,
          name: "已拒绝"
        }]
      }
    },
    mounted() {
      self = this;

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {

        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        laydate = layui.laydate;

        //时间控件
        laydate.render({
          elem: '#order_date',
          range: true,
          trigger: 'click',
          done: function(value, date, endDate) {
            self.page = 1;
            $("#order_date").val(value);
            self.get_recharge_record()
          }
        });

        form.on('select(status_selection)', function(data) {
          var val = $("select[name=status]").val() - 1;
          self.current_status = val;
          var status;
          if (val != -1) {
            status = self.status[self.current_status].id;
          } else {
            status = 0;
          }
          self.status_id = status; //获取当前站点
          self.get_recharge_record(true)
        });
        form.render('select');

        self.get_recharge_record()
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_recharge_record() {
        self.list = [];

        //获取的结束时间自动加一天
        var t = $("#order_date").val();
        var start_time, end_time;
        if (t) {
          self.getDate(t, function(s, e) {
            start_time = s;
            end_time = e;
          })
        }

        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        if (start_time) {
          param.append('start_time', start_time)
        }
        if (end_time) {
          param.append('end_time', end_time)
        }
        param.append('is_handle', self.status_id)

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/cash_list/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.count = datas.page.count;
            self.list = datas.list;
            if(datas.cash_res){
              self.money = datas.cash_res;
            }

            //总额统计
            if(datas.total){
              self.data_total.total = datas.total.toFixed(2);
              self.data_total.balance = (datas.total - datas.cashed).toFixed(2);
            }
            if(datas.cashed){
              self.data_total.cashed = datas.cashed.toFixed(2);
            }

            self.ShowPage(self, laypage, "get_recharge_record"); //分页
            $('.pagebox').show();
          }, false);

        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      submit (id,etype) {
        self.id = id;
        self.etype = etype;
        if (etype == 2) {
          self.Confirm.txt = "是否确认通过提现申请？";
        } else {
          self.Confirm.txt = "是否确认拒绝提现申请？";
        }
        self.Confirm.style = 1;
        self.Confirm.state = true;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          self.loading = true;
          self.Confirm.state = false;
          let param = new URLSearchParams()
          param.append('id', self.id);
          param.append('is_handle', self.etype);
          axios({
            method: 'post',
            url: self.GetServerUrl()+"/cash_handle/",
            data:param,
            headers: {'token': localStorage.getItem("ExShopee_token")}
          }).then(function (response) {
            //返回数据处理
            self.ReturnFuntion(self,response,function(datas){
              self.get_recharge_record();
              self.ToastFun(0, "操作成功！"); //弹窗提醒
            },false);

          }).catch(function (error) {
            self.loading = false;
            self.ToastFun(2, error); //弹窗提醒
          })
        }
      },
      withdraw (title) {
        layer.open({
          type: 1,
          offset: '100px',
          title: title,
          area: ['300px', '350px'],
          fixed: false, //不固定
          // btn: ['店铺授权', '查看我的店铺类型'],
          content: withdrawBox
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .table_img {
    width: 60px !important;
    height: 60px !important;
    border-radius: 100px;
  }

  .country_select {
    width: 150px;
  }

  .total-data {
    padding: 12px 10px;
    line-height: 18px;
  }

  .total-data-row {
    color: #444;
    padding-right: 30px;
    margin-right: 30px;
    border-right: 1px solid #CCC;
    font-family: Microsoft YaHei, arial;
    font-family: arial;
    font-size: 15px;
  }

  .total-data-row:last-child {
    border-right: 0;
  }
  .BalanceBox{
    padding:10px 20px;
    overflow: hidden;
    position: relative;
  }
  .BalanceList{
    float: left;
    width: 20%;
    max-width: 200px;
  }
  .BalanceTxt{
    color:#444;
    padding-bottom: 3px;
  }
  .BalanceCount{
    font-size: 18px;
    font-weight: bold;
  }
  .BalanceButton{
    position: absolute;
    right:20px;
    top:calc(50% - 18px);
    display: table;
    padding:5px 8px;
    background-color: #EEE;
    border:1px solid #CCC;
    border-radius: 3px;
    cursor: pointer;
  }
  .BalanceButton:hover{
    background-color: #E9E9E9;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/BalanceManage.vue